import { useState } from 'react';
import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/outline';

const processNames = { sb: "Stairs & Buckets", proc3: "Finding the Money", proc6: "Liability Wall" };

export default function CodeDetails({ codes }) {
    const [copiedId, setCopiedId] = useState(null);

    function isCodeRecent(createdAtSeconds) {
        const currentTimeSeconds = Math.floor(Date.now() / 1000);
        const oneMonthSeconds = 30 * 24 * 60 * 60; // Approximate seconds in one month
        return createdAtSeconds > currentTimeSeconds - oneMonthSeconds;
    }

    async function copyLink(codeId) {
        const link = `https://insuranceagencytraining.org/view/${codeId}`;
        try {
            await navigator.clipboard.writeText(link);
            setCopiedId(codeId);
            setTimeout(() => setCopiedId(null), 2000);
        } catch (error) {
            console.error('Failed to copy:', error);
        }
    }

    return (
        <div className="m-2">
            <ul>
                {codes && codes.length > 0 && (
                    <>
                        <ul className="space-y-1 divide-y">
                            <li className="overflow-hidden bg-white px-4 py-2 sm:px-6">
                                <div className="grid grid-cols-3 gap-4 items-center">
                                    <div className="font-bold text-sm text-green-700">
                                        Video
                                    </div>
                                    <div className="font-bold text-sm text-green-700">
                                        Link
                                    </div>
                                    <div className="font-bold text-sm text-green-700">
                                        Status
                                    </div>
                                </div>
                            </li>
                            {codes.map((code, index) => (

                                isCodeRecent(code.createdAt.seconds) && <li key={index} className="overflow-hidden bg-white px-4 py-2 sm:px-6">
                                    <div className="grid grid-cols-3 gap-4 items-center">
                                        <div className="text-sm text-gray-700">
                                            {processNames[code.process] || "Stairs & Buckets"} ({code.language || 'English'})
                                        </div>
                                        <div className="text-sm">
                                            <button
                                                onClick={() => copyLink(code.id)}
                                                className="inline-flex items-center gap-1 text-green-600 hover:text-green-700 hover:underline"
                                            >
                                                {copiedId === code.id ? (
                                                    <>
                                                        <CheckIcon className="h-4 w-4" />
                                                        Copied!
                                                    </>
                                                ) : (
                                                    <>
                                                        <ClipboardDocumentIcon className="h-4 w-4" />
                                                        Copy Link
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                        <div className={`text-sm font-bold ${code.opened ? "text-green-700" : "text-red-700"}`}>
                                            {code.opened ? "Opened" : "Not Opened"}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </>
                )}

                {codes && codes.length === 0 && (
                    <>
                        <div className="flex p-4 text-center align-center w-full justify-center">
                            <div className="flex flex-col items-center">
                                <p className="text-md font-semibold leading-6 text-gray-900">
                                    Looks like you haven't sent any video codes...
                                </p>
                            </div>
                        </div>
                    </>
                )}
            </ul>
        </div>
    );
}
